// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// const SESSION_DURATION = 10 * 60 * 1000; // 10 minutes
// const WARNING_BEFORE = 1 * 60 * 1000; // 1 minute

// const SessionManager = ({ children }) => {
//   const location = useLocation();

//   useEffect(() => {

//     // ✅ Skip session handling only for payment page
//     if (location.pathname === "/payment" || location.pathname === "/health-log") {
//       return;
//     }

    
//     const refreshSession = () => {
//       localStorage.setItem("sessionStart", Date.now().toString());
//     };

//     const checkSession = () => {
//       const sessionStart = parseInt(localStorage.getItem("sessionStart"), 10);
//       if (!sessionStart) return;

//       const now = Date.now();
//       const timeElapsed = now - sessionStart;

//       if (timeElapsed >= SESSION_DURATION) {
//         alert("Your session has expired.");
//         localStorage.removeItem("sessionStart");
//         localStorage.removeItem("authToken");
//         window.location.href = "/";
//       } 
//       else if (timeElapsed >= SESSION_DURATION - WARNING_BEFORE) {
//         const shouldExtend = window.confirm(
//           "Your session will expire soon. Extend it?"
//         );

//         if (shouldExtend) {
//           refreshSession();
//         }
//       }
//     };

//     // start session if not present
//     if (!localStorage.getItem("sessionStart")) {
//       refreshSession();
//     }

//     const interval = setInterval(checkSession, 30000);

//     // refresh session on user activity
//     window.addEventListener("click", refreshSession);
//     window.addEventListener("keypress", refreshSession);

//     return () => {
//       clearInterval(interval);
//       window.removeEventListener("click", refreshSession);
//       window.removeEventListener("keypress", refreshSession);
//     };

//   }, [location.pathname]);

//   return children;
// };

// export default SessionManager;

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { tokenStorage } from "../utils/tokenStorage";

const SESSION_DURATION = 10 * 60 * 1000; // 10 minutes
const WARNING_BEFORE  =  1 * 60 * 1000;  // warn 1 minute before

const SKIP_PATHS = ["/payment", "/health-log"];

const SessionManager = ({ children }) => {
  const location = useLocation();
  const { userId, logout } = useAuth();

  useEffect(() => {
    // ── Skip entirely if not logged in ──────────────────────────────────
    if (!userId || !tokenStorage.isLoggedIn()) return;

    // ── Skip specific pages ─────────────────────────────────────────────
    if (SKIP_PATHS.includes(location.pathname)) return;

    const refreshSession = () => {
      localStorage.setItem("sessionStart", Date.now().toString());
    };

    const checkSession = () => {
      // Re-check login state at tick time (user may have logged out)
      if (!tokenStorage.isLoggedIn()) return;

      const sessionStart = parseInt(localStorage.getItem("sessionStart"), 10);
      if (!sessionStart) return;

      const elapsed = Date.now() - sessionStart;

      if (elapsed >= SESSION_DURATION) {
        alert("Your session has expired.");
        tokenStorage.clear();
        logout();
        window.location.href = "/";
      } else if (elapsed >= SESSION_DURATION - WARNING_BEFORE) {
        const shouldExtend = window.confirm(
          "Your session will expire soon. Extend it?"
        );
        if (shouldExtend) refreshSession();
      }
    };

    // Initialise session start if not already set (login page sets it, but
    // this is a safe fallback for page refreshes mid-session)
    if (!localStorage.getItem("sessionStart")) {
      refreshSession();
    }

    const interval = setInterval(checkSession, 30000);

    window.addEventListener("click",    refreshSession);
    window.addEventListener("keypress", refreshSession);

    return () => {
      clearInterval(interval);
      window.removeEventListener("click",    refreshSession);
      window.removeEventListener("keypress", refreshSession);
    };
  }, [location.pathname, userId]); // re-run when login state changes

  return children;
};

export default SessionManager;